import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

const CustomModal = NiceModal.create(({ title, component, autoClose, size = 'lg' }) => {
  // Use NiceModal hook to manage the modal state
  const modal = useModal()
  
  const { t } = useTranslation()

  return (
    <Modal size={size} isOpen={modal.visible} toggle={() => autoClose ? modal.hide() : null} className='custom_nice_modal_m17'>
      <ModalHeader toggle={()=> modal.hide()}>{t(title)}</ModalHeader>
      <ModalBody>
        {component}
      </ModalBody>
    </Modal>
  )
})

export default CustomModal